import { LegacyImport } from '#settings/dev.legacy'
import { LegacyAvlExternalImport } from '#settings/dev.legacy.avl.external'
import { LegacyAvlRavImport } from '#settings/dev.legacy.avl.rav'
import { ExplainerPanel } from 'apprise-ui/utils/explainer'


export const DevSettingsPanel = () => {

    const style ={padding: "10px 20px", background: 'rgb(220 226 231)', marginBottom: 30, marginTop: 20, borderRadius: 4}


    return <ExplainerPanel style={{padding:20}} >

         <h2 style={style}>Import Vessels</h2>
        
        <LegacyImport />

        <br/>

         <h2 style={style}>Import AVL Declarations</h2>
        
        <LegacyAvlRavImport />

         <br/>

         <h2 style={style}>Import External AVL Declarations</h2>
        
        <LegacyAvlExternalImport />

    </ExplainerPanel>

}